export default function(param) {
  const query = {};
  window.location.search
    .slice(1)
    .split('&')
    .forEach(pair => {
      const parts = pair.split('=');
      query[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
    });

  return query[param];
}
